(function () {
    "use strict";
    const input = document.querySelector("#search-input");
    const placeholder = document.querySelector(".search-overlay__product-placeholder").children[0];
    const resultsWrap = document.querySelector(".search-overlay__items-wrap");
    const resultsButton = document.querySelector(".search-overlay__cta");
    const spinner = document.querySelector('.index-spinner__wrap');
    let currentRequest = null;
    let params = (new URL(document.location)).searchParams;
    let productID = params.get('id');
    var product = document.getElementById(productID);
    let scrollObject = new SmoothScroll();
    let productScrolledTo = false;

    new Ajaxinate({
        method: "scroll",
        container: "#searchLoop",
        pagination: "#searchPagination",
        callback: findProductInView
    });

    input.addEventListener("input", debounce(getSearchResults, 100));

    window.addEventListener('resize', function () {
        resultsButton.style.display = input.value && window.innerWidth < 720 ? "block" : "none";
    });

    if(productID) {
        if(!product){
            startScroll();
        } else {
            productScrolledTo = true;
            spinner.style.display = "none";
        }
    } else if(spinner) {
        spinner.style.display = "none";
    }

    function startScroll() {
        var button = document.querySelector('.search--button');
        scrollObject.animateScroll(button);
    }

    function getSearchResults(evt) {
        if (currentRequest) {
            currentRequest.abort();
        }
        if(evt.target.value){
            currentRequest = $.get(
                `/search/suggest.json?q=${evt.target.value}&resources[type]=product&resources[limit]=8`,
                function(res) {
                    const fragment = document.createDocumentFragment();
                    res.resources.results.products.forEach(function(productData) {
                        fragment.appendChild(buildProduct(productData));
                    });
                    resultsWrap.innerHTML = "";
                    if (fragment.childNodes.length) {
                        resultsWrap.appendChild(fragment);
                        resultsButton.style.display = evt.target.value && window.innerWidth < 720 ? "block" : "none";
                    } else {
                        resultsWrap.innerHTML = "<p>No results</p>";
                    }
                }
            );
        } else {
            resultsWrap.innerHTML = "";
            resultsButton.style.display = "none";
        }
    }

    function buildProduct(productData) {
        const product = placeholder.cloneNode(true);
        product.querySelector('.product-grid-item__wrap').href = productData.url + "&search=true";
        const img = product.querySelector("img");
        const imgUrl = productData.image;
        const cropStr = "_500x500_crop_center";
        const dotIndex = imgUrl.lastIndexOf(".");
        img.src = imgUrl.substring(0, dotIndex) + cropStr + imgUrl.substring(dotIndex);
        img.alt = productData.title;
        product.querySelector(".product-grid-item__name").innerText = productData.title;
        product.querySelector(".product-grid-item__price").innerText =
            "$" + productData.price.substring(0, productData.price.indexOf("."));
        return product;
    }

    function findProductInView () {
        if(productID){
            product = document.getElementById(productID);
            if(!product) {
                startScroll();
            } else if(!productScrolledTo){
                product.scrollIntoView();
                document.querySelector('.index-spinner__wrap').style.display = "none";
                productScrolledTo = true;
            }
        }
    }
})();
